import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

const MenuVersionField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="menuVersionLabel" value={restaurantForFullInfo?.restaurantMenuVersion} />;
};

export default MenuVersionField;
